module.exports = __webpack_public_path__ + "static/media/20-mobile.d1475236.jpg";